import { render, staticRenderFns } from "./ProductFilterContent.vue?vue&type=template&id=3dd3e632&scoped=true&"
import script from "./ProductFilterContent.vue?vue&type=script&lang=js&"
export * from "./ProductFilterContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd3e632",
  null
  
)

export default component.exports